import { CodeSection } from './code-subject-section';

export const CodeSectionAttoCollegatoList = [
  CodeSection.ATTO_COLLEGATO,
  CodeSection.ATTO_NASCITA_FIGLIO,
  CodeSection.ATTO_NASCITA_CONIUGE,
  CodeSection.ATTO_MATRIMONIO,
  CodeSection.ATTO_UNIONE_CIVILE,
  CodeSection.ATTO_NASCITA_UNITO,
  CodeSection.CITTADINANZA_ATTO_NASCITA,
  CodeSection.ATTO_RICONOSCIMENTO,
  CodeSection.ATTO_RICONOSCIMENTO_MADRE,
  CodeSection.ATTO_RICONOSCIMENTO_PADRE,
  CodeSection.ATTO_DI_CONSENSO_ATCO,
  CodeSection.ATTO_DI_CONSENSO_ATCOP,
  CodeSection.ATTO_CONSENSO_ATCOM,
  CodeSection.ATTO_CONSENSO_ATCOP,
  CodeSection.ATTO_ASSENSO_FIGLIO,
  CodeSection.ATTO_NOTARILE_CONSENSO_PADRE,
  CodeSection.ATTO_NOTARILE_CONSENSO_MADRE,
  CodeSection.ATTO_COLLEGATO_GEN,
  CodeSection.SCIOGLIMENTO_ATTO_UNIONE_CIVILE,
  CodeSection.MATRIMONIO_ATTO_NASCITA_SPOSO,
  CodeSection.MATRIMONIO_ATTO_NASCITA_SPOSA,
  CodeSection.MATRIMONIO_ATTO,
  CodeSection.ACCORDO_SEPARAZIONE,
  CodeSection.SEPARAZIONE_ATTO_ACCORDO,
  CodeSection.CONFERMA_ACCORDO_SEP,
  CodeSection.MATRIMONIO_ATTO_NASCITA_FIGLIO,
  CodeSection.CONSENSO_ATTO,
  CodeSection.SCIOGLIMENTO_ATTO_ACCORDO,
  CodeSection.NEGOZIAZIONE_ASSISTITA,
  CodeSection.MORTE_ATTO_NASCITA_DECEDUTO,
  CodeSection.UNIONE_CIVILE_ATTO_NASCITA_CONIUGE1,
  CodeSection.UNIONE_CIVILE_ATTO_NASCITA_CONIUGE2,
  CodeSection.ATTO_TRASCRITTO_C,
  CodeSection.ATTO_DA_RETTIFICARE,
  CodeSection.ATTO_COLLEGATO_CITTADINANZA,
  CodeSection.ATTO_ANNOTAZIONE_MODIFICATIVA,
];
